// Paradas avulsas da Logística — tarefas da rotina do gerente que não são
// pedidos, mas precisam aparecer no plano do dia e no PDF.
// Exemplos: "Pegar metalon na Lemadeiras", "Levar material pra Arco antes
// das entregas", "Passar na Cromaços pegar 5 corrediças".

export const TIPOS_PARADA = [
  { id: 'retirar',  label: 'Retirar',  cor: '#F97316', textCor: '#fff' },
  { id: 'entregar', label: 'Entregar', cor: '#10B981', textCor: '#fff' },
  { id: 'passar',   label: 'Passar',   cor: '#6366F1', textCor: '#fff' },
  { id: 'outro',    label: 'Outro',    cor: '#94A3B8', textCor: '#fff' },
]

export function labelTipoParada(id) {
  return TIPOS_PARADA.find(t => t.id === id)?.label || '—'
}

export function estiloTipoParada(id) {
  const t = TIPOS_PARADA.find(x => x.id === id)
  return t ? { cor: t.cor, textCor: t.textCor } : { cor: '#94A3B8', textCor: '#fff' }
}

function novoIdParada() {
  const ts = Date.now().toString(36)
  const rnd = Math.random().toString(36).slice(2, 6)
  return `par_${ts}_${rnd}`
}

export function criarParada({ data, descricao, tipo = 'passar', endereco = '', horarioEntrega = '' }) {
  return {
    id:             novoIdParada(),
    data,
    descricao:      descricao || '',
    endereco:       endereco || '',
    horarioEntrega: horarioEntrega || '',
    tipo,
    concluida:      false,
    ordem:          Date.now(),  // ordem inicial = momento de criação
    criadoEm:       new Date().toISOString(),
  }
}
